import React from 'react';
import {PureComponent} from 'react';
import CircularProgress from "housecall-ui/dist/DesignSystem/Feedback/Progress/CircularProgress"
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles'
import PropTypes from "prop-types";

const styles = theme => ({
    spinner: {
      backgroundColor: '#f7f7f7',
      position: 'absolute',
      zIndex: 20,
      top: 0,
      left: 0,
      opacity: 0.9,
      height: '100%',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
})
@withStyles(styles)
export default class ParentComponentSpinner extends PureComponent {
    render() {
        if (this.props.showSpinner) {
            return <div className={this.props.classes.spinner}>
                <CircularProgress/>
            </div>
        } else {
            return <div></div>
        }
    }
}

ParentComponentSpinner.PropTypes =  {
    showSpinner: PropTypes.bool.isRequired
}
